import axios from 'axios';

const API_URL = '/api/user';

export const createUser = async (userData) => {
  try {
    const response = await axios.post(API_URL, userData);
    return response.data;
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
}

export const loginUser = async (email, password) => {
  try {
    const response = await axios.post(`${API_URL}/login`, {email, password})
    return response.data;
  } catch (error) {
    console.error("Error logging in user: ", error);
    throw error;
  }
}

export const getUserInfo = async (userId) => {
  try {
    const response = await axios.get(`${API_URL}/${userId}`)
    return response.data;
  } catch (error) {
    console.error("Error getting user:", error);
    throw error;
  }
}